export enum PostLayout {
  Large = 'LARGE',
  Standard = 'STANDARD',
  Thumbnail = 'THUMBNAIL',
  Minimalist = 'MINIMALIST',
  Carousel = 'CAROUSEL'
}
